<template>
  <div>
    <div class="sepTop">
      <div v-for="item in items" :key="item.id">
        <GoldRecordItem :item="item"/>
      </div>
    </div>
    <Empty :stat="loadStat" :icon="require('@/static/ic_charge_empty.png')"/>
  </div>
</template>

<script>
import GoldRecordItem from "./GoldRecordItem";
import Empty from "../comm/Empty";
import config from "@/api/config";
import http from "../../api/http";


export default {
  name: "GoldRecord",
  components: {
    GoldRecordItem,
    Empty
  },
  data() {
    return {
      items: [],
      loadStat: 0
    }
  },
  mounted() {
    const url = config.baseUrl + "/VCurrency/Recharge/RechargeRecords"
    this.loadStat = 0
    http.post(url, {}).then(
        response => {
          this.items = response.detail
          this.loadStat = this.items && this.items.length != 0 ? 2 : 1
        },
        response => {
          console.log('GoldRecord.vue 请求失败' + response)
        }
    )
  }
}
</script>

<style scoped>

</style>